<app-dashboard-layout [loading]="loading" [downloader]="downloader">
  <app-notification-alert [data]="notification"></app-notification-alert>

  <form class="flex flex-col mx-auto max-w-screen-md p-4 z-20 justify-center space-y-6" (ngSubmit)="generateAdvice()">
    <h1 class="font-medium text-center text-lg">
      Select a session to generate payment advice
    </h1>

    <section *ngIf="skeletonLoader">
      <div class="border rounded-md bg-gray-300 h-16 my-8 animate-pulse"></div>
      <div class="border rounded-md mx-auto max-w-md bg-gray-300 h-8 my-8 animate-pulse"></div>
    </section>

    <section *ngIf="!skeletonLoader" class="space-y-4">
      <div class="bg-white border border-primary rounded-lg w-full p-2">
        <select
          id="session"
          [(ngModel)]="session"
          name="session"
          class="w-full mt-1 px-2 py-1 rounded focus:outline-none"
        >
          <option disabled value="">Select a Session</option>
          <option *ngFor="let s of sessions" [value]="s">{{ s }}</option>
        </select>
      </div>

      <div class="bg-white border border-primary rounded-lg w-full p-2">
        <select
          id="term"
          [(ngModel)]="term"
          name="term"
          class="w-full mt-1 px-2 py-1 rounded focus:outline-none"
        >
          <option disabled value="">Select a Term</option>
          <option *ngFor="let termOption of terms" [value]="termOption.Id">{{ termOption.Label }}</option>
        </select>
      </div>

      <app-button-primary class="w-full" [disabled]="loading" type="submit">
        Generate Advice
      </app-button-primary>
    </section>
  </form>
</app-dashboard-layout>
